import { lazy } from 'react';

export const StdraftorderPage = lazy(() => import('./page-list'));
